import {Injectable} from "@angular/core";
import {NativeWaiterAppService} from "../../native-waiter-app.service";

export class CardDetails {
    cardNumber: string;
    formattedCardNumber: string;
    expiry: string;
}

/**
 * When running in waiter mode on a native device, the credit cards can be scanned instead of manually entered
 */
@Injectable()
export class CardScanService {

    constructor(private nativeWaiterAppService: NativeWaiterAppService) {
        console.log("--- CardScanService");
    }

    /**
     * Indicates that the card scanner is available
     */
    isAvailable(): boolean {
        return this.nativeWaiterAppService.isAvailable();
    }

    scanCard(): Promise<CardDetails> {
        return new Promise<CardDetails>((resolve, reject) => {
            if (this.isAvailable()) {
                const s: string = this.nativeWaiterAppService.scanCreditCard();
                const result: any = JSON.parse(s);
                if (!result || !result.success) {
                    reject();
                } else {
                    const card: CardDetails = new CardDetails();
                    card.cardNumber = result.cardNumber;
                    card.expiry = result.expiry;
                    card.formattedCardNumber = result.formattedCardNumber;
                    resolve(card);
                }
            } else {
                reject();
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/payment/card-payment/card-scan.service.ts